// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T00:32:08.908Z
// Property: Uptown at Kirkland Urban (ID: 6737460151193489)
// Collections: 21 amenities, 43 floorplans (live), 30 photos, 39 POIs, 3 reviews, 3 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6737460151193489",
  "property_external_id": "1724162",
  "property_zillow_url": "https://www.zillow.com/apartments/kirkland-wa/uptown-at-kirkland-urban/CkBdMY/",
  "property_apartments_url": "https://www.apartments.com/uptown-at-kirkland-urban-kirkland-wa/56n95pn/",
  "property_google_business_url": "https://www.google.com/maps/place/Uptown+at+Kirkland+Urban/data=!4m2!3m1!1s0x0:0xd8f5b41ede7fae02?sa=X&ved=2ahUKEwjGmobK1bmSAxUh88kDHRXiNicQ_BJ6BAgUEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47571460889",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "uptown-at-kirkland-urban",
  "property_name": "Uptown at Kirkland Urban",
  "property_website_url": "https://www.uptownkirkland.com",
  "property_domain": "https://www.uptownkirkland.com",
  "property_address": "550 Uptown Court",
  "property_full_address": "550 Uptown Ct, Kirkland, WA 98033",
  "property_address_1": "550 Uptown Ct",
  "property_address_2": null,
  "property_address_city": "Kirkland",
  "property_address_state": "WA",
  "property_address_zip_full": "98033",
  "property_address_zip": "98033",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "Moss Bay",
  "property_address_latitude": "47.6787298",
  "property_address_longitude": "-122.198515",
  "property_email": "uptownkirkland@weidner.com",
  "property_phone": "(425) 728-6422",
  "property_call_tracking_phone": "425-728-6422",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Relaxed, elegant living in downtown Kirkland.</strong> Uptown at Kirkland Urban brings modern apartments, Lake Washington views, pet-friendly comfort, and easy I-405 access together in a warm, active community.</p>",
  "property_long_description": "Come home to relaxed, elegant living at Uptown at Kirkland Urban Apartments. Our apartments in downtown Kirkland are in a vibrant area near a Top Golf Lounge, the Kirkland waterfront, and several delicious restaurants. Uptown at Kirkland Urban offers modern apartments with useful amenities in a warm and active community. It's also pet-friendly, has views of Lake Washington, and is minutes from I-405.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with stainless steel appliances, white quartz countertops, and dark wood cabinetry.",
    "public_id": "019d01a6-2a05-7258-9f38-b5a72126f242",
    "storage_key": "property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
    "width": 1640,
    "height": 900
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "185",
  "property_year_built": "2019",
  "property_year_renovated": null,
  "property_walk_score": "90",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "91.8918918918919",
  "property_admin_fee": "250",
  "property_application_fee": "28",
  "property_fees_deposit_info": "Deposit: $600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "Varies",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "70",
  "property_pet_restrictions": "Breed restrictions apply. Pets over 70 lbs are subject to management interview.",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://uptownkirkland.securecafe.com/onlineleasing/uptown-at-kirkland-urban/floorplans.aspx",
  "property_resident_portal_url": "https://uptownkirkland.securecafenet.com/residentservices/uptown-at-kirkland-urban/userlogin",
  "property_apply_now_url": "https://uptownkirkland.securecafe.com/onlineleasing/uptown-at-kirkland-urban/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-1ec5-7069-a97a-bd331219e8c3.webp",
  "property_primary_logo_media": {
    "alt_text": "Uptown logo",
    "public_id": "019d01a7-1ec5-7069-a97a-bd331219e8c3",
    "storage_key": "property/6737460151193489/019d01a7-1ec5-7069-a97a-bd331219e8c3.webp",
    "width": 263,
    "height": 75
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a8-66d9-716f-8fd0-42ce6a044658.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d01a8-66d9-716f-8fd0-42ce6a044658",
    "storage_key": "property/6737460151193489/019d01a8-66d9-716f-8fd0-42ce6a044658.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019e083f-75ff-716e-9748-6ae4e7c2bfd7.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e083f-75ff-716e-9748-6ae4e7c2bfd7",
    "storage_key": "property/6737460151193489/019e083f-75ff-716e-9748-6ae4e7c2bfd7.webp",
    "width": 263,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019e083f-69d0-71a0-8c98-c1f6a30c50ea.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e083f-69d0-71a0-8c98-c1f6a30c50ea",
    "storage_key": "property/6737460151193489/019e083f-69d0-71a0-8c98-c1f6a30c50ea.webp",
    "width": 263,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#545353",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "481 - 1406",
  "property_sqft_min": "481",
  "property_sqft_max": "1406",
  "property_price_range": "7 - 4390",
  "property_price_min": "2240",
  "property_price_max": "4265",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/UptownAtKirklandUrbanApartments",
  "property_instagram_url": "https://www.instagram.com/uptownkirklandapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJCzPbcx8TkFQRAq5_3h609dg",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Uptown at Kirkland Urban",
  "property_home_romance_title": "Embrace Your Dream Lifestyle at Our Charming Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Polished, practical, connected.</strong> At Uptown at Kirkland Urban, everyday amenities work beautifully into your routine—from a 24-hour fitness center and bike storage with a work station to a conference room for focused time. Head up to the rooftop terrace for open-air seating, BBQs, and a fire pit, then come home to modern finishes like air conditioning, full-size front-loading laundry, stainless steel appliances, soft-close cabinetry, and select Lake Washington or city views.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with a polished Kirkland edge.</strong> Explore studio, one-bedroom, two-bedroom, and townhome-style floor plans with open, efficient, or extra-roomy designs. Hard-surface wood-look flooring, oversized windows with roller shades, air conditioning, and full-size front-loading laundry streamline every space, while select homes add kitchen islands, oversized closets, private balconies, or Lake Washington and city views.</p>",
  "property_home_gallery_blurb": "<p><strong>Preview Uptown at Kirkland Urban.</strong> Browse bright interiors with large windows, wood-look flooring, sleek kitchens, and select balconies with Lake Washington or city views. Then picture the extras: a rooftop terrace with lounge seating, BBQs, and a fire pit, plus polished community spaces like the resident lounge, fitness center, and bike storage.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Moss Bay brings Kirkland to your doorstep.</strong> From Uptown at Kirkland Urban, coffee, dinner, groceries, and entertainment are part of the plaza—think Caffe Ladro, Dough Zone, QFC, and Five Iron Golf. Just blocks away, Marina Park, Lake Street dining, Peter Kirk Park, and the Cross Kirkland Corridor add waterfront views, trails, and easy downtown energy.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents highlight service that stands out.</strong> Reviews often mention a warm, responsive leasing team, thoughtful tour guidance, attentive follow-through, and maintenance support that keeps things moving. Add in beautiful apartments, a nice gym, generous in-home storage, and everyday convenience in Moss Bay, and Uptown at Kirkland Urban earns praise for making the experience feel supported from the first visit onward.</p>",
  "property_neighborhood_blurb": "<p><strong>Moss Bay puts Kirkland at your pace.</strong> Step from Uptown at Kirkland Urban into an open-air mix of coffee, dinner, errands, and entertainment—Caffe Ladro, Dough Zone, QFC, Five Iron Golf, and more are woven right into the plaza. A few blocks west, downtown’s lakefront energy takes over with Marina Park, waterfront paths, seasonal events, and restaurants along Lake Street.</p><p>When you want room to move, Peter Kirk Park and the Cross Kirkland Corridor keep green space and trail time close, while Kirkland Transit Center and nearby I-405 make the Eastside and Seattle easy to reach. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how connected this Moss Bay address feels.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Elevate the everyday.</strong> At Uptown at Kirkland Urban, amenities are designed to make home feel polished, practical, and connected. Start the morning in the 24-hour fitness center, park your bike in dedicated storage with a work station, or take laptop time to the conference room when you need a quieter setting.</p><p>When the day winds down, the rooftop terrace brings open-air seating, BBQs, and a fire pit into your routine. Inside, your apartment keeps the same modern rhythm: air conditioning, full-size front-loading laundry, large windows with roller shades, stainless steel appliances, soft-close cabinetry, under-cabinet lighting, and select Lake Washington or city views. Explore the <a href=\"/gallery\">photo gallery</a>, compare <a href=\"/floor-plans\">available layouts</a>, or review the <a href=\"/pet-policy\">pet policy</a>.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Uptown at Kirkland Urban.</strong><br>Relaxed, elegant apartment living in downtown Kirkland awaits, with modern homes, a warm active community, pet-friendly living, and Lake Washington views minutes from I-405. Apply online today and take the next step toward calling Uptown home.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Contact the leasing team at Uptown at Kirkland Urban for details about our modern apartments, pet-friendly community, Lake Washington views, or directions to our downtown Kirkland location minutes from I-405.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Uptown at Kirkland Urban?</strong> Start here for quick answers about the community, leasing, amenities, and everyday living in our modern, pet-friendly apartments in downtown Kirkland. If you need more details, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the floor plan that fits your day.</strong> Browse studio, one-bedroom, two-bedroom, and townhome-style layouts at Uptown at Kirkland Urban, with options that feel efficient, open, or extra roomy without losing a polished, modern edge. Inside, hard-surface wood-look flooring, large windows with roller shades, air conditioning, and full-size front-loading laundry make everyday living feel streamlined.</p><p>Choose the details that matter most to you, from stainless steel appliances, full-height tile backsplashes, and soft-close cabinetry to select homes with kitchen islands, oversized closets, private balconies, or Lake Washington and city views. Compare current pricing and availability below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite Kirkland layout in person.</p>",
  "property_gallery_blurb": "<p><strong>See the spaces before you step inside.</strong> Browse the photo gallery for a closer look at Uptown at Kirkland Urban, from bright apartment interiors with large windows, wood-look flooring, and sleek kitchens to select balconies framing Lake Washington or city views.</p><p>Picture evenings on the rooftop terrace, where lounge seating, BBQs, and a fire pit set the scene, then move indoors to the resident lounge, fitness center, and bike storage that add polish to daily routines. Explore studio, one-bedroom, two-bedroom, and townhome-style layouts through images, then continue with <a href=\"/virtual-tours\">virtual tours</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the details in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Uptown at Kirkland Urban.</strong><br>Use the interactive map to browse available apartments in downtown Kirkland and see what surrounds home—from the waterfront and nearby dining to easy access minutes from I-405.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, routines, and rooftop evenings.</strong> At Uptown at Kirkland Urban, your pet-friendly home puts daily care within easy reach: a fenced-in pet exercise area gives dogs a convenient place to stretch, office treats add a warm welcome, and frequent Yappy Hours bring in photo ops, snacks, and visiting grooming.</p><p>Inside, hard-surface wood-look flooring, air conditioning, large windows with roller shades, and full-size front-loading laundry help keep pet life comfortable and low-fuss. Step out for a leashed walk around Moss Bay, then come back to seating, BBQs, and a fire pit on the <a href=\"/amenities\">rooftop terrace</a>. Review the policy details below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Uptown at Kirkland Urban fits your day-to-day routine with pets.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Uptown at Kirkland Urban lifestyle.</strong> If relaxed, elegant living in downtown Kirkland is what you love, invite friends to experience it too—from modern apartments and a warm, active community to pet-friendly living, Lake Washington views, and everyday convenience minutes from I-405.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Uptown at Kirkland Urban</strong><br>Manage everyday apartment needs from one convenient place. Pay rent, submit maintenance requests, and keep your account up to date while enjoying relaxed, elegant living in a warm, active downtown Kirkland community.</p>",
  "property_reviews_blurb": "<p><strong>See what residents are saying.</strong> In reviews for Uptown at Kirkland Urban, the leasing team earns frequent praise for being warm, responsive, and genuinely helpful—from Cori’s thoughtful tour support to Francisco’s attentive follow-through on requests and maintenance needs. Reviewers also call out “beautiful” apartments, a nice gym, plenty of in-home storage, and a location that adds everyday convenience in Moss Bay.</p><p>As you browse the ratings below, look for the details mentioned most: caring service, clear communication, and a home experience that feels well supported from tour to move-in and beyond.</p>",
  "property_created_at": "1752257392763",
  "property_scheduletour_blurb": "<p><strong>See Uptown at Kirkland Urban in person.</strong> Tour modern downtown Kirkland apartments with a relaxed, elegant feel, Lake Washington views, and a warm, active community. Schedule your visit today and experience the setting, style, and everyday ease for yourself.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out.</strong> We’ve received your inquiry, and the Uptown at Kirkland Urban leasing team will follow up soon. We look forward to sharing more about our modern apartments, relaxed elegance, warm community, pet-friendly living, and Lake Washington views in downtown Kirkland.</p>",
  "property_virtualtours_blurb": "<p><strong>Take the walkthrough on your time.</strong> Start with the Uptown Kirkland Fitness Center tour to see the 24-hour workout space from every angle, then step into Uptown Kirkland 221 and Unit 416 for an up-close look at the apartment finishes that define Uptown at Kirkland Urban. As you move through each tour, notice the large windows with roller shades, hard-surface wood-look flooring, stainless steel appliances, full-height tile backsplash, and soft-close cabinetry with under-cabinet lighting.</p><p>Use these virtual tours to narrow your favorites before visiting in Kirkland, then compare layouts on the <a href=\"/floor-plans\">floor plans</a> page or <a href=\"/schedule-a-tour\">schedule a tour</a> when you are ready to see the details in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Uptown at Kirkland Urban",
  "property_seo_title_home": "Uptown at Kirkland Urban |  Apartments in Kirkland, WA",
  "property_seo_description_home": "Elevate your lifestyle at Uptown at Kirkland Urban! Enjoy stunning views, a rooftop terrace, modern amenities, and stylish apartments. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Kirkland, WA Apartments for Rent",
  "property_seo_description_floorplans": "Discover your ideal lifestyle at Uptown at Kirkland Urban with our charming studio, one, and two-bedroom floor plans in Kirkland, WA!",
  "property_seo_title_amenities": "Amenities | Kirkland, WA Apartments for Rent",
  "property_seo_description_amenities": "Experience upscale living at Uptown at Kirkland Urban, where rooftop views, a top-tier gym, and pet-friendly comforts redefine home. Your ideal space awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Kirkland, WA",
  "property_seo_description_gallery": "Experience life at Uptown at Kirkland Urban! Enjoy breathtaking views, upscale amenities, a rooftop terrace, and a 24-hour fitness center!",
  "property_seo_title_virtualtours": "Virtual Tours | Uptown at Kirkland Urban Apartments",
  "property_seo_description_virtualtours": "Discover modern living at Uptown at Kirkland Urban! Take a virtual tour of our studios and apartments in Kirkland, WA, and find your home!",
  "property_seo_title_interactivemap": "Interactive Map | Uptown at Kirkland Urban Apartments",
  "property_seo_description_interactivemap": "Elevate your lifestyle at Uptown at Kirkland Urban! Check out our interactive map to find your perfect studio or one/two-bedroom apartment today.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Kirkland, WA",
  "property_seo_description_neighborhood": "Experience vibrant living at Uptown at Kirkland Urban. Discover local favorites and hidden gems in Kirkland, WA, just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Uptown at Kirkland Urban",
  "property_seo_description_contact": "Connect with Uptown at Kirkland Urban! From cozy studios to spacious two-bedrooms, our leasing team is ready to assist you. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Kirkland, WA",
  "property_seo_description_faqs": "Find quick answers to your questions about Uptown at Kirkland Urban. From stunning views to modern amenities, explore what makes our community exceptional!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kirkland, WA",
  "property_seo_description_reviews": "Experience life at Uptown at Kirkland Urban! Enjoy stunning views, modern amenities, and a vibrant community. Check out what our residents love about us!",
  "property_seo_title_applynow": "Apply Now | Apartments in Kirkland, WA",
  "property_seo_description_applynow": "Discover your dream home at Uptown, Kirkland Urban! Enjoy breathtaking views, a rooftop terrace, and modern amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Uptown at Kirkland Urban",
  "property_seo_description_residentaccess": "Log in to your Uptown at Kirkland Urban resident portal for hassle-free rent payments, maintenance requests, and community updates right at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | Uptown at Kirkland Urban",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Uptown at Kirkland Urban and share the exceptional lifestyle waiting for you in vibrant Kirkland, WA.",
  "property_seo_title_scheduletour": "Schedule a Tour | Uptown at Kirkland Urban",
  "property_seo_description_scheduletour": "Discover vibrant living at Uptown in Kirkland Urban! Schedule your tour today for a community where comfort meets convenience in beautiful Kirkland.",
  "property_seo_title_privacy": "Privacy Policy | Uptown at Kirkland Urban",
  "property_seo_description_privacy": "Your privacy matters at Uptown at Kirkland Urban. Discover how we protect your information while you enjoy beautiful Kirkland, WA!",
  "property_seo_title_accessibility": "Website Accessibility | Uptown at Kirkland Urban",
  "property_seo_description_accessibility": "Embrace comfort and convenience at Uptown at Kirkland Urban. We prioritize digital inclusion for all—ensuring accessibility in every aspect of our community.",
  "property_seo_title_sitemap": "Sitemap | Uptown at Kirkland Urban",
  "property_seo_description_sitemap": "Navigate your way to your new home at Uptown at Kirkland Urban! Access our sitemap for easy exploration of vibrant living spaces and exceptional amenities.",
  "property_seo_title_thankyou": "Thank You | Uptown at Kirkland Urban",
  "property_seo_description_thankyou": "Thank you for reaching out! A member of our Uptown at Kirkland Urban team will connect soon to help you find your perfect home in vibrant Kirkland, WA.",
  "property_seo_title_pets": "Pet Policy | Apartments in Kirkland, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793119460506",
  "amenities": [
    {
      "id": "ec_a80547902df6760ed3fff7cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183396",
      "title": "Beautiful rooftop terrace with seating, fire pit and BBQs",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2dfd73398d111c4e8e92cb67",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183399",
      "title": "State-of-the art, 24-hour fitness center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a37617a934d81172cb184938",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183401",
      "title": "Bike storage with work station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff4870fcace116a8ea08f53a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183404",
      "title": "Hard-surface wood-look flooring throughout",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1181d724a31d8f56d98f72f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183409",
      "title": "Full-size, front-loading washer and dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb83063d243a59d07116fbdd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183410",
      "title": "Air conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ab2efb3cf08cb1ecdd9073b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183412",
      "title": "Private balcony *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0995b4dc1d4649ee91ff395b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183413",
      "title": "Oversized closets *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_584d6bfdea82f9db68386781",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183403",
      "title": "Two color palettes to choose from",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_397eb44a5191b5bd7e1557ba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183397",
      "title": "Resident lounge with full kitchen, and large screen TV",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e16ec1a7cf89c5cf5c3b393e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183405",
      "title": "Large windows with roller shades",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_564d9b33ff6e266ff76dd453",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183398",
      "title": "Pet-friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e35a80deb8696537d94dd6d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183406",
      "title": "Textured, soft-close cabinetry with under-cabinet lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_009e82bf36deabb55f03923e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183400",
      "title": "Conference/meeting room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15b6721e28d31f5ed6c62d41",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183407",
      "title": "Full-height tile backsplash",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7452f0d6829188bc1dbf8e64",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183408",
      "title": "Stainless steel appliance package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c02bddce4093522433783e7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183402",
      "title": "Resident storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_173226d0245f57a6eac00ef1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "124799699",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92c70ec3494411ebda3843a0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183411",
      "title": "Lake Washington and city views *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_382c84123e3106b5096b39e1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183414",
      "title": "Kitchen islands *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78bd199dc761496aed140a68",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "121183415",
      "title": "Large soaker tub *",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_23e32c30e658be5f4bb07a01",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white quartz countertops, and dark wood cabinetry.",
        "public_id": "019d01a6-2a05-7258-9f38-b5a72126f242",
        "storage_key": "property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "This stylish apartment kitchen features sleek stainless steel appliances, a deep sink, ample counter space, and elegant cabinetry, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A kitchen here at Uptown at Kirkland Urban featuring sleek white countertops, modern stainless steel appliances, and stylish two-tone cabinetry, creating a bright, polished, and highly functional cooking space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(1).jpg"
    },
    {
      "id": "ec_a3e1c1a0a2574d16ccd99045",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-28a8-752b-8cd7-1046180315b8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, island with bar stools, and dining area.",
        "public_id": "019d01a6-28a8-752b-8cd7-1046180315b8",
        "storage_key": "property/6737460151193489/019d01a6-28a8-752b-8cd7-1046180315b8.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring stainless steel appliances, a large island with seating, and an adjacent dining space. Perfect for entertaining and everyday living.",
      "link": "false",
      "alt_text": "A kitchen here at Uptown at Kirkland Urban featuring a spacious white island with warm brown barstools, sleek stainless steel appliances, and modern cabinetry, creating a bright, welcoming, and stylish space for cooking and gathering.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(2).jpg"
    },
    {
      "id": "ec_42468c06bc0c5d67c093cada",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-2a06-738d-9a73-201073819f6c.webp",
      "image_media": {
        "alt_text": "Modern living room with sofa, chairs, coffee table, and large windows with city views.",
        "public_id": "019d01a6-2a06-738d-9a73-201073819f6c",
        "storage_key": "property/6737460151193489/019d01a6-2a06-738d-9a73-201073819f6c.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Stylish and spacious living area, perfect for relaxing or entertaining, featuring contemporary furniture and abundant natural light.",
      "link": "false",
      "alt_text": "A living room here at Uptown at Kirkland Urban featuring a deep green sofa, light patterned rug, and woven accent table, creating a bright, inviting space with large windows and stylish, modern décor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(3).jpg"
    },
    {
      "id": "ec_77ef4d42477e91546a452c55",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-28f6-7581-b3c1-cc5f517e505a.webp",
      "image_media": {
        "alt_text": "Modern apartment living room and kitchen area with gray sofa and armchair.",
        "public_id": "019d01a6-28f6-7581-b3c1-cc5f517e505a",
        "storage_key": "property/6737460151193489/019d01a6-28f6-7581-b3c1-cc5f517e505a.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious and stylish apartment featuring a modern living area with comfortable seating and a well-appointed kitchen, perfect for everyday living.",
      "link": "false",
      "alt_text": "A living room here at Uptown at Kirkland Urban featuring a gray sofa and matching gray armchair, warm wood coffee table, and neutral rug, creating a cozy, modern space with clean lines and inviting décor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(4).jpg"
    },
    {
      "id": "ec_906faff0ef356c0b8f8c8ed9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-3412-744f-9b27-cd6c237df9a7.webp",
      "image_media": {
        "alt_text": "Home office area with a desk, chair, and artwork, overlooking a cityscape.",
        "public_id": "019d01a6-3412-744f-9b27-cd6c237df9a7",
        "storage_key": "property/6737460151193489/019d01a6-3412-744f-9b27-cd6c237df9a7.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Create a productive and stylish home office in this apartment, featuring a classic wooden desk, comfortable seating, and inspiring artwork.",
      "link": "false",
      "alt_text": "A home office here at Uptown at Kirkland Urban featuring a dark wood desk and woven chair, bright window with scenic view, tripod floor lamp, and neutral rug, creating a peaceful, productive workspace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(5).jpg"
    },
    {
      "id": "ec_f99092e54fc14d791c085cc0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-35d4-76af-a18c-4297fabdb2ff.webp",
      "image_media": {
        "alt_text": "Modern loft kitchen and living area with staircase",
        "public_id": "019d01a6-35d4-76af-a18c-4297fabdb2ff",
        "storage_key": "property/6737460151193489/019d01a6-35d4-76af-a18c-4297fabdb2ff.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious loft-style apartment featuring a modern kitchen, open living space, and a striking staircase leading to the upper level.",
      "link": "false",
      "alt_text": "A loft living area here at Uptown at Kirkland Urban featuring a bright kitchen with white island, stainless appliances, open staircase with wood steps, and airy high ceilings, creating a modern, inviting space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(6).jpg"
    },
    {
      "id": "ec_34a2c969768e3afd5cd836e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-36e5-7469-91e6-2da313f1a5f2.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, macrame wall hanging, and a window with a view.",
        "public_id": "019d01a6-36e5-7469-91e6-2da313f1a5f2",
        "storage_key": "property/6737460151193489/019d01a6-36e5-7469-91e6-2da313f1a5f2.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush queen bed and tasteful decor.",
      "link": "false",
      "alt_text": "A bedroom here at Uptown at Kirkland Urban featuring bright white bedding, a soft taupe throw, warm wood nightstands, and a cozy textured rug, creating a calm, inviting space with beautiful natural light and window views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(7).jpg"
    },
    {
      "id": "ec_ef3b971252a6739a90c57a6c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019e0b22-b6bf-7779-b673-9545a879be54.webp",
      "image_media": {
        "alt_text": "Modern bathroom with bathtub, vanity, and sink.",
        "public_id": "019e0b22-b6bf-7779-b673-9545a879be54",
        "storage_key": "property/6737460151193489/019e0b22-b6bf-7779-b673-9545a879be54.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Elegant and spacious bathroom featuring a deep soaking tub, a sleek vanity with a modern sink, and a large backlit mirror. Perfect for relaxation.",
      "link": "false",
      "alt_text": "A bathroom with a white toilet and a white bathtub.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban%20(8).jpg"
    },
    {
      "id": "ec_6247d613a78ab44ce9722c66",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-3593-739d-87a0-cea7e30fd2f6.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-sized bed, wood headboard, and decorative pillows.",
        "public_id": "019d01a6-3593-739d-87a0-cea7e30fd2f6",
        "storage_key": "property/6737460151193489/019d01a6-3593-739d-87a0-cea7e30fd2f6.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable king-sized bed with a modern wooden headboard and plush bedding, creating a relaxing retreat.",
      "link": "false",
      "alt_text": "A bedroom here at Uptown at Kirkland Urban featuring crisp white bedding, a chunky cream knit throw, warm wood headboard, and brown and black accent pillows, creating a cozy, modern, inviting retreat.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(8).jpg"
    },
    {
      "id": "ec_e241c4c338340a71b40c5eb0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-3f5b-70dc-af56-c1a1aa3f9e6a.webp",
      "image_media": {
        "alt_text": "Stackable washer and dryer in a bathroom with a shower curtain.",
        "public_id": "019d01a6-3f5b-70dc-af56-c1a1aa3f9e6a",
        "storage_key": "property/6737460151193489/019d01a6-3f5b-70dc-af56-c1a1aa3f9e6a.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "In-unit stackable washer and dryer conveniently located within the apartment bathroom.",
      "link": "false",
      "alt_text": "A laundry area here at Uptown at Kirkland Urban featuring a stacked white washer and dryer beside a clean, bright bathroom with a light shower curtain, creating a convenient, modern setup.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(9).jpg"
    },
    {
      "id": "ec_4c9b8ae8a09544fc261236df",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-4275-77e8-972e-fbacf8da1698.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and a small table, overlooking the courtyard.",
        "public_id": "019d01a6-4275-77e8-972e-fbacf8da1698",
        "storage_key": "property/6737460151193489/019d01a6-4275-77e8-972e-fbacf8da1698.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee on this spacious balcony, complete with seating and a table, overlooking the beautifully landscaped courtyard.",
      "link": "false",
      "alt_text": "A private balcony here at Uptown at Kirkland Urban with two white woven chairs and a small round table, offering a bright, peaceful outdoor retreat with modern railing and welcoming neighborhood views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(10).jpg"
    },
    {
      "id": "ec_0739b39dd2a5ab0cf7de5df3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-4556-7777-b783-f4bb53474a3e.webp",
      "image_media": {
        "alt_text": "Well-equipped apartment fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019d01a6-4556-7777-b783-f4bb53474a3e",
        "storage_key": "property/6737460151193489/019d01a6-4556-7777-b783-f4bb53474a3e.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a full range of cardio and strength training equipment for your workout needs.",
      "link": "false",
      "alt_text": "A modern fitness center here at Uptown at Kirkland Urban with treadmills, strength machines, and free weights, featuring bright lighting, expansive windows, and a clean, motivating space for energizing daily workouts.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(11).jpg"
    },
    {
      "id": "ec_c2f99b7cece850f1d28db193",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-573a-75af-a329-63fa819d46d5.webp",
      "image_media": {
        "alt_text": "Indoor bike storage area with racks and a bike repair station.",
        "public_id": "019d01a6-573a-75af-a329-63fa819d46d5",
        "storage_key": "property/6737460151193489/019d01a6-573a-75af-a329-63fa819d46d5.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Secure and convenient indoor bike storage featuring ample racks and a dedicated repair station, perfect for cyclists.",
      "link": "false",
      "alt_text": "A secure bike storage room here at Uptown at Kirkland Urban featuring organized wall-mounted racks, clean concrete floors, exposed modern ductwork, and bright windows, creating a convenient and well-maintained space for residents’ bicycles.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(16).jpg"
    },
    {
      "id": "ec_c27076c72a5269088d95d8f6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-4929-73da-8404-c7b7cce0d8d9.webp",
      "image_media": {
        "alt_text": "Communal lounge area with an open kitchen and outdoor seating.",
        "public_id": "019d01a6-4929-73da-8404-c7b7cce0d8d9",
        "storage_key": "property/6737460151193489/019d01a6-4929-73da-8404-c7b7cce0d8d9.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy our modern communal lounge, featuring a fully equipped open kitchen and comfortable seating both indoors and outdoors. Perfect for socializing or working.",
      "link": "false",
      "alt_text": "A stylish resident lounge here at Uptown at Kirkland Urban with modern dining tables, a sleek kitchen, and large glass doors opening to a landscaped patio, creating a bright, social space for relaxing or entertaining.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(12).jpg"
    },
    {
      "id": "ec_6510748d3a556ff1db336f79",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019e0b22-b6f9-7373-8c9e-98b23bfae5f1.webp",
      "image_media": {
        "alt_text": "Modern lobby with a reception desk, seating area, and a woman using a laptop.",
        "public_id": "019e0b22-b6f9-7373-8c9e-98b23bfae5f1",
        "storage_key": "property/6737460151193489/019e0b22-b6f9-7373-8c9e-98b23bfae5f1.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Welcome to our stylish lobby, featuring a contemporary reception area and comfortable lounge spaces perfect for relaxing or working.",
      "link": "false",
      "alt_text": "A woman is sitting on a blue couch in a modern living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban%20(15).jpg"
    },
    {
      "id": "ec_549a12798a6feae1f0b5dc89",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019e0b22-b804-747d-8fb6-20ce00d7eb5f.webp",
      "image_media": {
        "alt_text": "Modern lounge area with large sectional sofa, coffee table, TV, and floor-to-ceiling windows overlooking a courtyard.",
        "public_id": "019e0b22-b804-747d-8fb6-20ce00d7eb5f",
        "storage_key": "property/6737460151193489/019e0b22-b804-747d-8fb6-20ce00d7eb5f.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish resident lounge, featuring comfortable seating, entertainment options, and beautiful views of the community courtyard.",
      "link": "false",
      "alt_text": "A modern living room with a grey sofa and a black entertainment center.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban%20(16).jpg"
    },
    {
      "id": "ec_6f24e632e1498d50be5192a5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019e0b22-b749-723b-b1ab-7b27aa3c3122.webp",
      "image_media": {
        "alt_text": "Stylish communal lounge area with comfortable seating, a coffee table, and a large TV mounted on a wood-paneled wall.",
        "public_id": "019e0b22-b749-723b-b1ab-7b27aa3c3122",
        "storage_key": "property/6737460151193489/019e0b22-b749-723b-b1ab-7b27aa3c3122.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed communal lounge. Perfect for socializing or enjoying a quiet moment.",
      "link": "false",
      "alt_text": "A living room with a wooden wall and a flat screen TV mounted on it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban%20(17).jpg"
    },
    {
      "id": "ec_0ac1e67f1373280099673ea2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-552d-76b3-8a98-d65c60720ffc.webp",
      "image_media": {
        "alt_text": "Modern lounge area with blue walls, a large TV, a sofa, and a round table with chairs.",
        "public_id": "019d01a6-552d-76b3-8a98-d65c60720ffc",
        "storage_key": "property/6737460151193489/019d01a6-552d-76b3-8a98-d65c60720ffc.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a large screen TV, and elegant decor. Perfect for socializing or quiet contemplation.",
      "link": "false",
      "alt_text": "A modern resident lounge here at Uptown at Kirkland Urban featuring a bold blue accent wall, cozy gray sofa, wood console table with blush ottomans, sleek TV setup, and soft contemporary lighting, creating a comfortable and inviting gathering space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(15).jpg"
    },
    {
      "id": "ec_627e4fa99942cb6dbd9e80a4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-4a3f-776f-ae58-a45868ae1f48.webp",
      "image_media": {
        "alt_text": "Modern lounge area with booth seating, tables, and a large wooden counter.",
        "public_id": "019d01a6-4a3f-776f-ae58-a45868ae1f48",
        "storage_key": "property/6737460151193489/019d01a6-4a3f-776f-ae58-a45868ae1f48.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge area, featuring comfortable booth seating, modern tables, and a rustic wooden counter, perfect for socializing or quiet moments.",
      "link": "false",
      "alt_text": "A cozy resident lounge here at Uptown at Kirkland Urban with warm tan booth seating, sleek black tables, brass pendant lighting, and a textured brick accent wall, creating an inviting, modern space for gathering or relaxing.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(13).jpg"
    },
    {
      "id": "ec_99d7d0cd4c3bfae556fff6a1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-53a6-7478-8b69-b0099d8a42ff.webp",
      "image_media": {
        "alt_text": "Communal seating area with exposed brick wall and leather booths.",
        "public_id": "019d01a6-53a6-7478-8b69-b0099d8a42ff",
        "storage_key": "property/6737460151193489/019d01a6-53a6-7478-8b69-b0099d8a42ff.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy a comfortable and stylish communal seating area, perfect for working or socializing. Features exposed brick accents and plush leather booths.",
      "link": "false",
      "alt_text": "A stylish resident lounge here at Uptown at Kirkland Urban with warm tan booth seating, a striking live-edge wood table, brass pendant lighting, and a textured brick accent wall, creating a welcoming, modern gathering space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(14).jpg"
    },
    {
      "id": "ec_cb717cbd0dc693e21cb9bf59",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-57ab-75ad-8da9-25e5367c67ee.webp",
      "image_media": {
        "alt_text": "Interior view of a storage unit facility with rows of storage unit doors.",
        "public_id": "019d01a6-57ab-75ad-8da9-25e5367c67ee",
        "storage_key": "property/6737460151193489/019d01a6-57ab-75ad-8da9-25e5367c67ee.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Secure and convenient storage solutions available on-site for residents.",
      "link": "false",
      "alt_text": "A spacious storage area here at Uptown at Kirkland Urban featuring secure individual storage units, clean concrete floors, and bright overhead lighting, creating a convenient and organized space for residents’ extra belongings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(17).jpg"
    },
    {
      "id": "ec_212b125bd55f02a07fbd4d2b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019e0b22-ba5d-7616-9670-d648fa0335e2.webp",
      "image_media": {
        "alt_text": "Outdoor communal area with seating, a ping pong table, and modern buildings in the background.",
        "public_id": "019e0b22-ba5d-7616-9670-d648fa0335e2",
        "storage_key": "property/6737460151193489/019e0b22-ba5d-7616-9670-d648fa0335e2.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy the modern amenities and vibrant community spaces, featuring comfortable seating and recreational options like a ping pong table.",
      "link": "false",
      "alt_text": "A patio with chairs and a table is in front of a building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban%20(22).jpg"
    },
    {
      "id": "ec_42619291714900ef4ea17944",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019e0b22-ca20-74cf-b67d-48a35b8c7a81.webp",
      "image_media": {
        "alt_text": "People relaxing on a rooftop patio with string lights and a fire pit.",
        "public_id": "019e0b22-ca20-74cf-b67d-48a35b8c7a81",
        "storage_key": "property/6737460151193489/019e0b22-ca20-74cf-b67d-48a35b8c7a81.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Lifestyle",
      "description": "Enjoy the outdoors and the stunning city views from our rooftop patio, complete with comfortable seating, a fire pit, and ambient string lighting.",
      "link": "false",
      "alt_text": "Two people sitting on a bench on a rooftop patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban%20(23).jpg"
    },
    {
      "id": "ec_0eeff31ee0b0de3939e8eb6f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-6012-700a-bb19-c0d239b7f9ea.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with string lights, seating, and a fire pit at dusk.",
        "public_id": "019d01a6-6012-700a-bb19-c0d239b7f9ea",
        "storage_key": "property/6737460151193489/019d01a6-6012-700a-bb19-c0d239b7f9ea.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy the evening air on our rooftop lounge, complete with comfortable seating, a fire pit, and ambient string lighting, offering stunning city views.",
      "link": "false",
      "alt_text": "A rooftop lounge here at Uptown at Kirkland Urban featuring cozy seating, warm string lights, and landscaped planters, creating a stylish and inviting space with beautiful evening views of the surrounding city and water.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(18).jpg"
    },
    {
      "id": "ec_1ab0a93b8f1332317c897cb8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-64a1-73f8-8383-1dcb69960978.webp",
      "image_media": {
        "alt_text": "Rooftop patio with fire pit, seating, foosball table, and string lights at dusk.",
        "public_id": "019d01a6-64a1-73f8-8383-1dcb69960978",
        "storage_key": "property/6737460151193489/019d01a6-64a1-73f8-8383-1dcb69960978.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy evenings on the rooftop patio, complete with a cozy fire pit, comfortable seating, a fun foosball table, and ambient string lights.",
      "link": "false",
      "alt_text": "A rooftop lounge here at Uptown at Kirkland Urban featuring a fire pit, foosball table, and modern seating, with warm string lights and landscaped planters creating a welcoming, relaxing atmosphere overlooking the surrounding neighborhood at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(19).jpg"
    },
    {
      "id": "ec_4cbb9efede0a535a56c688e2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019e0b22-c972-751f-9c8a-0303a86cbdba.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with balconies and courtyard amenities including a ping pong table.",
        "public_id": "019e0b22-c972-751f-9c8a-0303a86cbdba",
        "storage_key": "property/6737460151193489/019e0b22-c972-751f-9c8a-0303a86cbdba.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Experience modern living in this vibrant apartment community, featuring stylish exteriors, private balconies, and a beautiful courtyard with recreational amenities.",
      "link": "false",
      "alt_text": "A modern apartment complex with a courtyard and two people walking.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban%20(27).jpg"
    },
    {
      "id": "ec_6dd7e4672767fb4a876c15e6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a6-6459-77fe-b00e-b3b5ef9bf7a9.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with balconies and clean landscaping.",
        "public_id": "019d01a6-6459-77fe-b00e-b3b5ef9bf7a9",
        "storage_key": "property/6737460151193489/019d01a6-6459-77fe-b00e-b3b5ef9bf7a9.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Exterior view of the Uptown apartment building, showcasing its contemporary architecture and well-maintained grounds.",
      "link": "false",
      "alt_text": "A building exterior here at Uptown at Kirkland Urban featuring modern architecture, glass-railed balconies, and warm wood accents, with landscaped greenery and inviting walkways creating a welcoming, upscale community setting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban_Favorites%20(20).jpg"
    },
    {
      "id": "ec_4af9661efa47de2777d543e6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019e0b22-c9b1-73e6-ac30-2f32d39ddd66.webp",
      "image_media": {
        "alt_text": "Street view of a commercial district with shops and cafes.",
        "public_id": "019e0b22-c9b1-73e6-ac30-2f32d39ddd66",
        "storage_key": "property/6737460151193489/019e0b22-c9b1-73e6-ac30-2f32d39ddd66.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "A vibrant street scene featuring various shops and cafes, including Zoka Coffee, with pedestrian and vehicle traffic.",
      "link": "false",
      "alt_text": "A busy street with cars and a cyclist in front of a Zora Coffee store.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban%20(26).jpg"
    },
    {
      "id": "ec_4c7e007b4811d4f6d8cc4b13",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019e0b22-cc59-77ac-b2e3-65e84eca05c8.webp",
      "image_media": {
        "alt_text": "Waterfront view of a park with trees and people enjoying the beach.",
        "public_id": "019e0b22-cc59-77ac-b2e3-65e84eca05c8",
        "storage_key": "property/6737460151193489/019e0b22-cc59-77ac-b2e3-65e84eca05c8.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy the serene waterfront lifestyle with our community's beautiful park, perfect for relaxation and outdoor activities by the water.",
      "link": "false",
      "alt_text": "A serene lake surrounded by trees and a building in the distance under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban%20(29).jpg"
    },
    {
      "id": "ec_5120412c1805f6a1a435be75",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019e0b22-ccbd-75aa-9b5c-21c94186d781.webp",
      "image_media": {
        "alt_text": "People relaxing by the water on a sunny day near a fountain.",
        "public_id": "019e0b22-ccbd-75aa-9b5c-21c94186d781",
        "storage_key": "property/6737460151193489/019e0b22-ccbd-75aa-9b5c-21c94186d781.webp",
        "width": 1640,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy the beautiful waterfront and serene atmosphere of our community, complete with walking paths and a soothing fountain.",
      "link": "false",
      "alt_text": "A park with people sitting on a bench and walking along the waterfront.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Uptown_at_Kirkland_Urban%20(30).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_03ef9c4c-da1c-4082-a0db-5b637765b65c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "DERU Market",
      "poi_type": "Restaurants",
      "poi_address": "723 9th Ave, Ste D, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-ad5d-718e-a936-6f64960f3162.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-ad5d-718e-a936-6f64960f3162",
        "storage_key": "property/6737460151193489/019d01a7-ad5d-718e-a936-6f64960f3162.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/deru-market-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.6820752,-122.1941814",
      "poi_item_slug": "deru-market-kirkland",
      "poi_latitude": "47.6820752",
      "poi_longitude": "-122.1941814",
      "poi_miles_from_property": "0.29",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+14252980268",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ9SkOAusSkFQRH1ho03tioGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_314d178d-fa5b-4258-87b4-c44c6b8816d3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Isarn Thai Soul Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "170 Lake St S, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "Isarn Thai Soul Kitchen is a Thai restaurant serving regional and street food favorites from Isan (Northeast Thailand), as well as some personal chef favorites from Southern and Central Bangkok. The menu features fresh and flavorful dishes made with authentic Thai ingredients and cooking techniques.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-ad5e-76cc-a675-7e902452d7da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-ad5e-76cc-a675-7e902452d7da",
        "storage_key": "property/6737460151193489/019d01a7-ad5e-76cc-a675-7e902452d7da.webp",
        "width": 666,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/isarn-thai-soul-kitchen-kirkland-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.67424,-122.2058",
      "poi_item_slug": "isarn-thai-soul-kitchen-kirkland-2",
      "poi_latitude": "47.67424",
      "poi_longitude": "-122.2058",
      "poi_miles_from_property": "0.48",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+14252984429",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJj6QLlt0SkFQRBaloZMZivyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fde9f7eb-76ee-4917-8938-d42d8bd39eba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Bottle & Bull",
      "poi_type": "Restaurants",
      "poi_address": "105 Lake St S, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "Experience the travels of Ernest Hemingway through your palette; eating and drinking your way through the cities that Hemingway loved to frequent; Havana, Paris, Florence and Pamplona (where he discovered his love for bull fighting!) to name a few. We focus on locally sourced, farm-to-table menus with hand crafted cocktails, as fluid as the seasons. Like Ernest Hemingway our hunger knows no borders!",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-add2-73fb-9b86-be2fdec5ab0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-add2-73fb-9b86-be2fdec5ab0b",
        "storage_key": "property/6737460151193489/019d01a7-add2-73fb-9b86-be2fdec5ab0b.webp",
        "width": 1000,
        "height": 552
      },
      "poi_business_url": "https://www.yelp.com/biz/bottle-and-bull-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.6752022,-122.2066184",
      "poi_item_slug": "bottle-and-bull-kirkland",
      "poi_latitude": "47.6752022",
      "poi_longitude": "-122.2066184",
      "poi_miles_from_property": "0.48",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+14252984972",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJRy_eh90SkFQRVQWY3ZRE_jM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d0390fc2-ef30-4f18-aefb-0a5d4878523d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Supreme Dumplings - Kirkland",
      "poi_type": "Restaurants",
      "poi_address": "120 Park Ln, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "We are creating moments of joy with good food. Visit us soon for the most authentic soup dumplings(xiaolongbao) and other small bites of happiness developed by a former executive chef of the W Hotel Taipei.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-ad95-7448-87e5-2c4d9f87156d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-ad95-7448-87e5-2c4d9f87156d",
        "storage_key": "property/6737460151193489/019d01a7-ad95-7448-87e5-2c4d9f87156d.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/supreme-dumplings-kirkland-kirkland-3?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.676291,-122.206102",
      "poi_item_slug": "supreme-dumplings-kirkland-kirkland-3",
      "poi_latitude": "47.676291",
      "poi_longitude": "-122.206102",
      "poi_miles_from_property": "0.43",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+18773092755",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ0R1nX4wTkFQRx0BP8StFWpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f87a3853-8765-4e4a-8ac4-f6eeee15b706",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Rimini Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3 Lake St, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "Salute this new unique Italian dining experience created by a familiar, award-winning restaurant family. The Nardone’s are multi time, nationally acclaimed restaurateurs and founders of some of the top restaurants in America along with world renowned Italian artist Tony La Stella.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-b0cf-7773-a951-613c9eaafb4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-b0cf-7773-a951-613c9eaafb4d",
        "storage_key": "property/6737460151193489/019d01a7-b0cf-7773-a951-613c9eaafb4d.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/rimini-restaurant-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.67567,-122.2068",
      "poi_item_slug": "rimini-restaurant-kirkland",
      "poi_latitude": "47.67567",
      "poi_longitude": "-122.2068",
      "poi_miles_from_property": "0.47",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+14252420070",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJFbYQ_JgTkFQR6yX_SUgb9MU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1599493e-e429-4a35-8e08-424d01cb2c03",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "University of Washington",
      "poi_type": "Universities",
      "poi_address": "1410 NE Campus Parkway, Seattle, WA 98195",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-b19e-755b-ac89-1d370b6ee6a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-b19e-755b-ac89-1d370b6ee6a5",
        "storage_key": "property/6737460151193489/019d01a7-b19e-755b-ac89-1d370b6ee6a5.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/university-of-washington-seattle-8?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.656568,-122.312748",
      "poi_item_slug": "university-of-washington-seattle-8",
      "poi_latitude": "47.656568",
      "poi_longitude": "-122.312748",
      "poi_miles_from_property": "5.56",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+12065432100",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_81e78d43-768c-4a2d-b6a0-17041124cf23",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Northwest University",
      "poi_type": "Universities",
      "poi_address": "5520 108th Ave NE, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "Northwest University is a regionally accredited, Christian institution awarding associate, bachelor’s, master’s, and doctoral degrees. Located in Kirkland, Washington, we have been preparing students to lead in their careers since 1934 and offer a variety of degree programs to meet the needs of an ever-changing society. Our traditional undergraduate experience includes over 70 majors and programs—as well as off-campus internships—to equip students for success in their careers. With our adult evening program, working adults can earn their degree by attending class on campus just one night each week. And our online degree programs provide the flexibility of classes that can be accessed anytime, anywhere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-b16e-7199-a0ab-5ca4fb2014e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-b16e-7199-a0ab-5ca4fb2014e4",
        "storage_key": "property/6737460151193489/019d01a7-b16e-7199-a0ab-5ca4fb2014e4.webp",
        "width": 760,
        "height": 506
      },
      "poi_business_url": "https://www.yelp.com/biz/northwest-university-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.65842,-122.19479",
      "poi_item_slug": "northwest-university-kirkland",
      "poi_latitude": "47.65842",
      "poi_longitude": "-122.19479",
      "poi_miles_from_property": "1.46",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+14258228266",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJTbB5LSttkFQR0bdtYSpl48c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_962eb447-f75f-4372-a341-1d0eb0760873",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "DigiPen Institute of Technology",
      "poi_type": "Universities",
      "poi_address": "9931 Willows Rd, Redmond, WA 98052",
      "poi_short_description": "",
      "poi_long_description": "DigiPen Institute of Technology is a private college located in Redmond, Washington, dedicated to preparing students for creative careers in the game and technology industries. In 1996, DigiPen became the first school in the world to offer a four-year degree program dedicated to video game technology and development. Today, DigiPen offers additional bachelor’s and master’s degree programs in digital art and animation, music and audio design, computer science, and game design. DigiPen student games have been downloaded over 10 million times on Steam, and graduates have been credited on more than 2,000 commercial games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-b237-729e-96bf-9ef9735a0950.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-b237-729e-96bf-9ef9735a0950",
        "storage_key": "property/6737460151193489/019d01a7-b237-729e-96bf-9ef9735a0950.webp",
        "width": 1000,
        "height": 666
      },
      "poi_business_url": "https://www.yelp.com/biz/digipen-institute-of-technology-redmond?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.68924,-122.15048",
      "poi_item_slug": "digipen-institute-of-technology-redmond",
      "poi_latitude": "47.68924",
      "poi_longitude": "-122.15048",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+18664785236",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJE_uiGFwNkFQRcq8Bfh2XoC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_58706bd1-1aa4-4e01-8bfc-98ccf37ac0e1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Bastyr University",
      "poi_type": "Universities",
      "poi_address": "14500 Juanita Dr NE, Kenmore, WA 98028",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-b4e0-701c-95af-ca6d14602de1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-b4e0-701c-95af-ca6d14602de1",
        "storage_key": "property/6737460151193489/019d01a7-b4e0-701c-95af-ca6d14602de1.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/bastyr-university-kenmore?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.7300018007496,-122.251850903255",
      "poi_item_slug": "bastyr-university-kenmore",
      "poi_latitude": "47.7300018007496",
      "poi_longitude": "-122.251850903255",
      "poi_miles_from_property": "4.35",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+14256023000",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5dfc64a1-7f1e-4865-82f3-a29be6c9eb6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Lake Washington Institute Of Technology",
      "poi_type": "Universities",
      "poi_address": "11605 132nd Ave NE, Kirkland, WA 98034",
      "poi_short_description": "",
      "poi_long_description": "As the only public institute of technology in Washington state, Lake Washington Institute of Technology (LWTech) a provides students with the latest cutting edge skills relevant to today’s workplace. LWTech offers eight applied bachelor’s degrees, more than 40 associate degrees, and more than 91 professional certificates in 42 areas of study, including STEM-focused programs in Science, Technology, Engineering, and Math.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-b5ca-7428-8fbf-e725ca30dd6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-b5ca-7428-8fbf-e725ca30dd6a",
        "storage_key": "property/6737460151193489/019d01a7-b5ca-7428-8fbf-e725ca30dd6a.webp",
        "width": 1000,
        "height": 439
      },
      "poi_business_url": "https://www.yelp.com/biz/lake-washington-institute-of-technology-kirkland-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.704702732484186,-122.1670273",
      "poi_item_slug": "lake-washington-institute-of-technology-kirkland-2",
      "poi_latitude": "47.70470273248419",
      "poi_longitude": "-122.1670273",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+14257398100",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJeVTZ7XkNkFQRPDEe_fRIdIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f5fcd35e-3ac7-4bff-a644-54f9658efb7c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "The HOP - The House of Pumps",
      "poi_type": "Gyms",
      "poi_address": "210 8th St S, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "The House of Pumps is a family-owned gym in downtown Kirkland. We are owned by 2 IFBB Pro's, and are the biggest 24/7 gym in the Greater Eastside. We offer 25$ training sessions, lifestyle and competition nutrition plans, and a gym that suits any gym-goers needs. We have an amazing community that fosters growth and respect, and we would love to see you in our gym! This isn't just a gym, we're a community.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-b60b-7662-a17b-f542c0f9a8ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-b60b-7662-a17b-f542c0f9a8ad",
        "storage_key": "property/6737460151193489/019d01a7-b60b-7662-a17b-f542c0f9a8ad.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/the-hop-the-house-of-pumps-kirkland-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.67413574301116,-122.1927124",
      "poi_item_slug": "the-hop-the-house-of-pumps-kirkland-2",
      "poi_latitude": "47.67413574301116",
      "poi_longitude": "-122.1927124",
      "poi_miles_from_property": "0.39",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+14255002998",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJcde4ynATkFQRlEpzygRZ9tE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5571f6eb-86c5-4739-934c-2e063c6e1a8b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Kirkland Community Fitness",
      "poi_type": "Gyms",
      "poi_address": "1015 7th Ave, Ste 140, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-b624-762c-9963-7b05fe0f01ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-b624-762c-9963-7b05fe0f01ab",
        "storage_key": "property/6737460151193489/019d01a7-b624-762c-9963-7b05fe0f01ab.webp",
        "width": 1000,
        "height": 666
      },
      "poi_business_url": "https://www.yelp.com/biz/kirkland-community-fitness-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.68041,-122.19098",
      "poi_item_slug": "kirkland-community-fitness-kirkland",
      "poi_latitude": "47.68041",
      "poi_longitude": "-122.19098",
      "poi_miles_from_property": "0.33",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+12068981810",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJCW8DJ8ASkFQR6vo3AFdSAQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9a1fbe59-392e-4ea5-a5f6-6d2722e4109b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "bStrong Personal Training",
      "poi_type": "Gyms",
      "poi_address": "989 112th Ave NE, Ste 102, Bellevue, WA 98004",
      "poi_short_description": "",
      "poi_long_description": "Get strong, healthy, and confident with personal training at bStrong. We’re a locally owned gym in downtown Bellevue specializing in strength training and interval-based workouts that deliver real results. New to fitness or strength training? No problem. Our expert coaches offer personalized support to help you build a strong foundation and create habits that last. Join our welcoming community and experience effective, coach-led training in a supportive environment. We offer two convenient Bellevue locations—both with locker rooms, showers, and free parking. You can also check out our brand new Redmond location! Ready to get started? Schedule your free intro call today.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-b96c-72a9-be71-bfc1a49d0bdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-b96c-72a9-be71-bfc1a49d0bdd",
        "storage_key": "property/6737460151193489/019d01a7-b96c-72a9-be71-bfc1a49d0bdd.webp",
        "width": 841,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/bstrong-personal-training-bellevue-4?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.61909,-122.19139",
      "poi_item_slug": "bstrong-personal-training-bellevue-4",
      "poi_latitude": "47.61909",
      "poi_longitude": "-122.19139",
      "poi_miles_from_property": "4.12",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+14254296952",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJkV7zeYxskFQRQFb2KLpNiQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f1cdda98-9efb-4b63-b16b-8d8ee7994b68",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Acuo CrossFit",
      "poi_type": "Gyms",
      "poi_address": "8545 152nd Ave NE, Redmond, WA 98052",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-b9f6-731d-8c2e-a8b6e002dd1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-b9f6-731d-8c2e-a8b6e002dd1b",
        "storage_key": "property/6737460151193489/019d01a7-b9f6-731d-8c2e-a8b6e002dd1b.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/acuo-crossfit-redmond-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.680156,-122.138442",
      "poi_item_slug": "acuo-crossfit-redmond-2",
      "poi_latitude": "47.680156",
      "poi_longitude": "-122.138442",
      "poi_miles_from_property": "2.76",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+14253071800",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJJdRZgVMNkFQRmldbI95lLxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d373a3fb-4b4c-48fe-8e98-fec7b6efe72a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Eastside Gym",
      "poi_type": "Gyms",
      "poi_address": "15040 NE 95th St, Redmond, WA 98052",
      "poi_short_description": "",
      "poi_long_description": "Eastside Gym of Redmond WA, is dedicated to body conditioning and weight training in an environment that promotes positive attitudes and personal development. Eastside is an independent gym, not a franchise, and is designed for true personal gains. Personal training is available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-b9f7-70fb-9e19-135f34437acf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-b9f7-70fb-9e19-135f34437acf",
        "storage_key": "property/6737460151193489/019d01a7-b9f7-70fb-9e19-135f34437acf.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/eastside-gym-redmond?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.68619,-122.139846",
      "poi_item_slug": "eastside-gym-redmond",
      "poi_latitude": "47.68619",
      "poi_longitude": "-122.139846",
      "poi_miles_from_property": "2.74",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+14258827764",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJy4TmyVoNkFQRQZ7CcujNQ2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dbcd7838-8d2d-4a3f-ad54-0ee93cab1780",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Kirkland Co-Operative Pre-School",
      "poi_type": "Elementary Schools",
      "poi_address": "7525 132nd Ave NE, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-b9f7-70fb-9e19-14826afb42e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-b9f7-70fb-9e19-14826afb42e6",
        "storage_key": "property/6737460151193489/019d01a7-b9f7-70fb-9e19-14826afb42e6.webp",
        "width": 512,
        "height": 768
      },
      "poi_business_url": "https://www.yelp.com/biz/kirkland-co-operative-pre-school-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.672213835734205,-122.1648629",
      "poi_item_slug": "kirkland-co-operative-pre-school-kirkland",
      "poi_latitude": "47.6722138357342",
      "poi_longitude": "-122.1648629",
      "poi_miles_from_property": "1.59",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+14258670818",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJrZP11rMSkFQR-AdiVlGTIhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_955dbd98-598f-4889-a89d-a8f321c62592",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Orion Montessori",
      "poi_type": "Elementary Schools",
      "poi_address": "11120 127th Ave NE, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-be6c-70d1-9133-857051780dfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-be6c-70d1-9133-857051780dfd",
        "storage_key": "property/6737460151193489/019d01a7-be6c-70d1-9133-857051780dfd.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/orion-montessori-kirkland-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.70054,-122.17167",
      "poi_item_slug": "orion-montessori-kirkland-2",
      "poi_latitude": "47.70054",
      "poi_longitude": "-122.17167",
      "poi_miles_from_property": "1.94",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+14254993313",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJezZfrn0NkFQRu7CiolQQC9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4ccc4d25-1108-438a-a0e2-f6d41645d5a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Bright Horizons at Kirkland",
      "poi_type": "Elementary Schools",
      "poi_address": "520 Kirkland Way, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "At Bright Horizons, our Discovery Driven Learning® approach makes early learning an adventure. Visit us to find out how we nurture your child’s natural curiosity, focus on what interests them most, encourage learning through play, and help them get ready for school success. Bright Horizons child care centers, preschools and schools include a premier early education curriculum and knowledgeable educators and teachers who meet the needs of children at every age and stage. At Bright Horizons, you’ll find infant or toddler care, preschool and pre K programs, kindergarten, elementary schools, and Montessori schools. We also understand the many needs of working parents.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-beda-7094-bd90-36a796cba973.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-beda-7094-bd90-36a796cba973",
        "storage_key": "property/6737460151193489/019d01a7-beda-7094-bd90-36a796cba973.webp",
        "width": 340,
        "height": 340
      },
      "poi_business_url": "https://www.yelp.com/biz/bright-horizons-kirkland-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.6763775,-122.1989846",
      "poi_item_slug": "bright-horizons-kirkland-kirkland",
      "poi_latitude": "47.6763775",
      "poi_longitude": "-122.1989846",
      "poi_miles_from_property": "0.16",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+14253121691",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJiYk8ksISkFQR3LJIZ5sQ-DM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6d546777-4306-4ed0-af49-9e1512701f9b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Rose Hill Christian Preschool",
      "poi_type": "Elementary Schools",
      "poi_address": "12202 NE 90th St, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/rose-hill-christian-preschool-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.68313,-122.17788",
      "poi_item_slug": "rose-hill-christian-preschool-kirkland",
      "poi_latitude": "47.68313",
      "poi_longitude": "-122.17788",
      "poi_miles_from_property": "0.96",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+14258227061",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJV6umor0SkFQRVidNhs1CbWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f2a9d935-e111-44cc-acb6-91ac98365839",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Kirkland Children's School",
      "poi_type": "Elementary Schools",
      "poi_address": "5311 108th Ave NE, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-beca-75a0-9eb7-d790bcca5983.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-beca-75a0-9eb7-d790bcca5983",
        "storage_key": "property/6737460151193489/019d01a7-beca-75a0-9eb7-d790bcca5983.webp",
        "width": 640,
        "height": 427
      },
      "poi_business_url": "https://www.yelp.com/biz/kirkland-childrens-school-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.6560299693068,-122.196712551769",
      "poi_item_slug": "kirkland-childrens-school-kirkland",
      "poi_latitude": "47.6560299693068",
      "poi_longitude": "-122.196712551769",
      "poi_miles_from_property": "1.56",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+14258225664",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJWzgmT9VskFQRL1y-Pcn5T8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1a9ba48f-14da-4852-addf-479a96490f47",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "The Jewish Day School",
      "poi_type": "High Schools",
      "poi_address": "15749 NE 4th St, Bellevue, WA 98008",
      "poi_short_description": "",
      "poi_long_description": "JDS is a Preschool through 8th grade independent school located in the Crossroads neighborhood of Bellvue, WA.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-becf-73b8-b43b-a5c349217bac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-becf-73b8-b43b-a5c349217bac",
        "storage_key": "property/6737460151193489/019d01a7-becf-73b8-b43b-a5c349217bac.webp",
        "width": 1000,
        "height": 397
      },
      "poi_business_url": "https://www.yelp.com/biz/the-jewish-day-school-bellevue-4?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.612919,-122.1283035",
      "poi_item_slug": "the-jewish-day-school-bellevue-4",
      "poi_latitude": "47.612919",
      "poi_longitude": "-122.1283035",
      "poi_miles_from_property": "5.57",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+14254600200",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJDb3FELZtkFQRYfOwHhx5410",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c75acd99-3160-4c44-a7f0-be11260d1958",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Lake Washington High School",
      "poi_type": "High Schools",
      "poi_address": "12033 NE 80th St, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-c2b7-74cb-ae3a-0a33c9340398.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-c2b7-74cb-ae3a-0a33c9340398",
        "storage_key": "property/6737460151193489/019d01a7-c2b7-74cb-ae3a-0a33c9340398.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/lake-washington-high-school-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.6752667,-122.1800647",
      "poi_item_slug": "lake-washington-high-school-kirkland",
      "poi_latitude": "47.6752667",
      "poi_longitude": "-122.1800647",
      "poi_miles_from_property": "0.87",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+14259361700",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJSTYViLgSkFQRmixJpC2APYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_49b6476c-6b9e-4ce1-92d4-75a53bd79386",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Eastside Preparatory School",
      "poi_type": "High Schools",
      "poi_address": "10613 NE 38th Pl, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-c26c-7611-8691-01d685757dfc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-c26c-7611-8691-01d685757dfc",
        "storage_key": "property/6737460151193489/019d01a7-c26c-7611-8691-01d685757dfc.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/eastside-preparatory-school-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.64361858530055,-122.19900021368694",
      "poi_item_slug": "eastside-preparatory-school-kirkland",
      "poi_latitude": "47.64361858530055",
      "poi_longitude": "-122.1990002136869",
      "poi_miles_from_property": "2.42",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+14258225668",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJN0dnNMVskFQR-55qYs1UIfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_948e9b62-8b78-458f-997c-040eba653342",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "The Perkins School",
      "poi_type": "High Schools",
      "poi_address": "9005 Roosevelt Way NE, Seattle, WA 98115",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-c39b-76ab-985c-cebb31b622a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-c39b-76ab-985c-cebb31b622a2",
        "storage_key": "property/6737460151193489/019d01a7-c39b-76ab-985c-cebb31b622a2.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/the-perkins-school-seattle-3?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.6942672729492,-122.318016052246",
      "poi_item_slug": "the-perkins-school-seattle-3",
      "poi_latitude": "47.6942672729492",
      "poi_longitude": "-122.318016052246",
      "poi_miles_from_property": "5.71",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+12065268217",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJ2Wvl7vcTkFQRbZogqglQMdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_30ee4881-ddb2-466f-99ac-70ef93483680",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "The Kineo School",
      "poi_type": "Private Schools",
      "poi_address": "7525 132nd Ave NE, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "A School That Celebrates Every Student! At The Kineo School, we embrace diversity and individuality. Our tailored approach supports neurodivergent students, including those with ADHD, learning disabilities and autism, helping them blossom. Small class sizes and a strong emphasis on social-emotional learning make Kineo a magnet for many families.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.yelp.com/biz/the-kineo-school-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.67224,-122.16463",
      "poi_item_slug": "the-kineo-school-kirkland",
      "poi_latitude": "47.67224",
      "poi_longitude": "-122.16463",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJq6q62LMSkFQRRkWCeZozd7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1a5427dc-83b1-418d-ba5d-061ad420fabc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Spring Academy",
      "poi_type": "Private Schools",
      "poi_address": "9725 3rd Ave NE, Ste 125, Seattle, WA 98115",
      "poi_short_description": "",
      "poi_long_description": "Spring Academy is a one-to-one, private, alternative school for grades 6-12. We offer open enrollment throughout the year for full-time, dual enrollment and part-time programs. We also offer 1:1 summer school courses, credit recovery, or tutoring in math, reading, and writing. We enable success for students who want a customized education or experience challenges with learning disabilities, ADHD or autism/Asperger's. At Spring Academy, we personalize everything from the students schedule and courses, to the lesson pacing, teaching methods, and instructional style. Our 1-to-1 approach allows us to connect and transform each students relationship and attitude towards learning.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-c242-73e1-a9f9-2d8164dc97d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-c242-73e1-a9f9-2d8164dc97d8",
        "storage_key": "property/6737460151193489/019d01a7-c242-73e1-a9f9-2d8164dc97d8.webp",
        "width": 480,
        "height": 360
      },
      "poi_business_url": "https://www.yelp.com/biz/spring-academy-seattle?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.7000553,-122.3268343",
      "poi_item_slug": "spring-academy-seattle",
      "poi_latitude": "47.7000553",
      "poi_longitude": "-122.3268343",
      "poi_miles_from_property": "6.19",
      "poi_walking_minutes": "4 hours 36 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+12063633600",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJF9VZ91kRkFQRpAGGd6PRFJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_03dde591-285c-46e5-97b2-f69ad1ae94c2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Laurel Academy",
      "poi_type": "Private Schools",
      "poi_address": "12700 35th Ave NE, Seattle, WA 98125",
      "poi_short_description": "",
      "poi_long_description": "Laurel Academy is a Private Elementary School in North Seattle offering placement in early entry kindergarten through 5th grade Learning and growing are naturally exciting activities. As one of the top Seattle Private Schools in Washington State, we aim to keep them that way. We want our students to flourish and become the foundation for a better world through real education. Students at Laurel Academy are given highly personal attention in our 1:10 classrooms with a focus on demonstrated application and competence instead of memorization and grade scores. Our program provides a hands-on experience for rich understanding so each child can use what he or she learns.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-c5d6-713d-863b-c56b353eb9d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-c5d6-713d-863b-c56b353eb9d8",
        "storage_key": "property/6737460151193489/019d01a7-c5d6-713d-863b-c56b353eb9d8.webp",
        "width": 960,
        "height": 314
      },
      "poi_business_url": "https://www.yelp.com/biz/laurel-academy-seattle?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.7211387447934,-122.290304288886",
      "poi_item_slug": "laurel-academy-seattle",
      "poi_latitude": "47.7211387447934",
      "poi_longitude": "-122.290304288886",
      "poi_miles_from_property": "5.21",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+12065225992",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJux3Sgm4UkFQRe0coeNE1neY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fdb1f6a4-f882-49b8-a1fd-0aa5c3b534a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Stellar Montessori Academy",
      "poi_type": "Private Schools",
      "poi_address": "2015 Richards Rd, Bellevue, WA 98005",
      "poi_short_description": "",
      "poi_long_description": "Montessori Preschool",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-c6e7-7519-9c2e-76465c46337b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-c6e7-7519-9c2e-76465c46337b",
        "storage_key": "property/6737460151193489/019d01a7-c6e7-7519-9c2e-76465c46337b.webp",
        "width": 1000,
        "height": 562
      },
      "poi_business_url": "https://www.yelp.com/biz/stellar-montessori-academy-bellevue-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.59247,-122.16502",
      "poi_item_slug": "stellar-montessori-academy-bellevue-2",
      "poi_latitude": "47.59247",
      "poi_longitude": "-122.16502",
      "poi_miles_from_property": "6.14",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+14254454428",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJcbee8UFzkFQR9QI0sGR9KUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c6be76e5-8447-480d-99f2-f065cac5606c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Epiphany School",
      "poi_type": "Private Schools",
      "poi_address": "3611 E Denny Way, Seattle, WA 98122",
      "poi_short_description": "",
      "poi_long_description": "Epiphany School is an independent elementary school in Seattle serving students in Pre-K through 5th grade. Founded in 1958, our school is known for excellent academics, strong social-emotional learning, and a warm, family-friendly atmosphere in which every child is truly known. Our talented faculty weave the school's core values of respect, responsibility, and resourcefulness into each grade's learning experience, helping every student grow in character, independence, confidence, and leadership over time. Epiphany School believes that close collaboration and partnership with students and their families is paramount to creating a learning environment in which children stretch, grow, and thrive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-c716-7148-bdd1-219cadcbe92a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-c716-7148-bdd1-219cadcbe92a",
        "storage_key": "property/6737460151193489/019d01a7-c716-7148-bdd1-219cadcbe92a.webp",
        "width": 612,
        "height": 408
      },
      "poi_business_url": "https://www.yelp.com/biz/epiphany-school-seattle?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.618157,-122.2867538",
      "poi_item_slug": "epiphany-school-seattle",
      "poi_latitude": "47.618157",
      "poi_longitude": "-122.2867538",
      "poi_miles_from_property": "5.88",
      "poi_walking_minutes": "3 hours 41 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+12063239011",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJFesuby9rkFQRswEEohsyaIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8a1b69b4-7148-40fe-95ed-408382de4adf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Nyanza Bridal",
      "poi_type": "Shopping",
      "poi_address": "123 Lake St S, Ste 102, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "The ultimate in bridal luxury, Nyanza is a glamorous, chic and utterly exclusive boutique for upscale, sophisticated brides in the Seattle Area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-c82e-7388-aff0-630047d53a65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-c82e-7388-aff0-630047d53a65",
        "storage_key": "property/6737460151193489/019d01a7-c82e-7388-aff0-630047d53a65.webp",
        "width": 800,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/nyanza-bridal-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.67473,-122.20639",
      "poi_item_slug": "nyanza-bridal-kirkland",
      "poi_latitude": "47.67473",
      "poi_longitude": "-122.20639",
      "poi_miles_from_property": "0.49",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+14256293781",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJqzW8yd0TkFQRaVeF_NRlRNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6b3aa961-7f5b-4ee4-8e94-2ff3ebed0ddd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Lake Street Diamond Company",
      "poi_type": "Shopping",
      "poi_address": "106 Lake St, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "Welcome to Lake Street Diamond Company! As a proud women-owned business, we offer exquisite jewelry with the largest diamond selection in the Pacific Northwest. Our legacy spans four generations, and we provide exceptional craftsmanship, personalized service, and a wide range of options. From stunning ethically sourced diamonds to 14k-22k gold jewelry and gold bullion, we have something for everyone. We believe in transparency and education, empowering you with the information you need to make an informed decision. Visit us and experience the beauty and expertise that define Lake Street Diamond Company.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-ca51-7410-9aed-4eb58147aaa4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-ca51-7410-9aed-4eb58147aaa4",
        "storage_key": "property/6737460151193489/019d01a7-ca51-7410-9aed-4eb58147aaa4.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/lake-street-diamond-company-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.67571,-122.20646",
      "poi_item_slug": "lake-street-diamond-company-kirkland",
      "poi_latitude": "47.67571",
      "poi_longitude": "-122.20646",
      "poi_miles_from_property": "0.45",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+14258229440",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJnXtHeecSkFQRRl24bJAopTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_606f4a44-3ee3-47d8-9708-d050f54e6b42",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Mox Boarding House - Bellevue",
      "poi_type": "Shopping",
      "poi_address": "13310 Bel-Red Rd, Bellevue, WA 98005",
      "poi_short_description": "",
      "poi_long_description": "Mox Boarding House Bellevue is your local board gaming café — come relax in our restaurant and play hundreds of games for free while enjoying delicious food, handcrafted cocktails, and local brews! Host your own special occasions (or just upgrade your weekly game night) inside our gorgeous bookable private rooms. Browse our incredible selection of roleplaying games, card games, miniatures, and board games of all kinds. Gather around the table every day of the week, because there's something at Mox Bellevue for the whole family!",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-cb3c-709f-b521-1e29a846937d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-cb3c-709f-b521-1e29a846937d",
        "storage_key": "property/6737460151193489/019d01a7-cb3c-709f-b521-1e29a846937d.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/mox-boarding-house-bellevue-bellevue-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.62288,-122.16282",
      "poi_item_slug": "mox-boarding-house-bellevue-bellevue-2",
      "poi_latitude": "47.62288",
      "poi_longitude": "-122.16282",
      "poi_miles_from_property": "4.18",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+14253263050",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJo8wNCFZskFQRrlQ9Fdyv2eE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2394aa5e-ee9c-425f-8518-33e398cf8acf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "T Anthony Jewelers",
      "poi_type": "Shopping",
      "poi_address": "2245 Carillon Point, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "T. Anthony Jewelers is a custom fine jewelry studio specializing in bridal jewelry and fine fashion jewelry",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-cb7b-731f-b925-c99574d76fff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-cb7b-731f-b925-c99574d76fff",
        "storage_key": "property/6737460151193489/019d01a7-cb7b-731f-b925-c99574d76fff.webp",
        "width": 666,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/t-anthony-jewelers-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.656742393663265,-122.2065355996442",
      "poi_item_slug": "t-anthony-jewelers-kirkland",
      "poi_latitude": "47.65674239366327",
      "poi_longitude": "-122.2065355996442",
      "poi_miles_from_property": "1.57",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+12069102670",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJvV3vIksVkFQRHb77-1kdwRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_76fedd7d-5ef3-456d-99ec-c9ebc3146ec6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Vape Savvy",
      "poi_type": "Shopping",
      "poi_address": "8427 122nd Ave NE, Ste 8427, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "Vape Savvy Kirkland and Redmond were established in September of 2018. We are customer obsessed! We offer high quality vape products and e-liquid, 420, disposables, Kratom, CBD, and wellness products. We have been consistently voted the Eastside's Premier Vape Shop. We have an amazing Rewards Program that has grown to over 12,000 members! We look forward to the privilege of serving you soon.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-cc8e-769e-b7ed-fa898cfe1c8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-cc8e-769e-b7ed-fa898cfe1c8a",
        "storage_key": "property/6737460151193489/019d01a7-cc8e-769e-b7ed-fa898cfe1c8a.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/vape-savvy-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.678838250868054,-122.17895038425922",
      "poi_item_slug": "vape-savvy-kirkland",
      "poi_latitude": "47.67883825086805",
      "poi_longitude": "-122.1789503842592",
      "poi_miles_from_property": "0.87",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+12069995572",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJSbGPrngTkFQRqvBfr_jFiBY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4b6c876a-12a6-481d-89f3-8cbcfb8ad93c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Canvas",
      "poi_type": "Entertainment",
      "poi_address": "223 Kirkland Ave, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-cdf6-730f-b1b1-2bd1529654b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-cdf6-730f-b1b1-2bd1529654b4",
        "storage_key": "property/6737460151193489/019d01a7-cdf6-730f-b1b1-2bd1529654b4.webp",
        "width": 563,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/canvas-kirkland-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.6751337,-122.2037595",
      "poi_item_slug": "canvas-kirkland-2",
      "poi_latitude": "47.6751337",
      "poi_longitude": "-122.2037595",
      "poi_miles_from_property": "0.37",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+14258222266",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJIwr-CucSkFQRGY4pqHZpDIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_00c68c2d-7b5f-41b3-a4d9-c550fc5b7c8c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "The Melody Lynne Vineyard",
      "poi_type": "Entertainment",
      "poi_address": "106 Kirkland Ave, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "Local family-owned winebar serving delicious small plates and boasting a wide variety of wines from our vineyard in Eastern Washington.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-cf2b-7507-a0d1-58b1de5ad7a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-cf2b-7507-a0d1-58b1de5ad7a9",
        "storage_key": "property/6737460151193489/019d01a7-cf2b-7507-a0d1-58b1de5ad7a9.webp",
        "width": 750,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/the-melody-lynne-vineyard-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.67567,-122.20584",
      "poi_item_slug": "the-melody-lynne-vineyard-kirkland",
      "poi_latitude": "47.67567",
      "poi_longitude": "-122.20584",
      "poi_miles_from_property": "0.44",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+14259414830",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJIw_1fucSkFQR-tlj8VgY_gY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ca59b8c0-0216-4437-a159-0e546cfed2b2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "DeLille Cellars",
      "poi_type": "Entertainment",
      "poi_address": "14300 NE 145th St, Ste 101, Woodinville, WA 98072",
      "poi_short_description": "",
      "poi_long_description": "DeLille Cellars is a top-rated Woodinville winery with over 900 individual 90+ ratings and numerous placements on Top 100 lists from leading critics. The winery is considered a principal influence in establishing Washington State as a premier viticultural region, maintaining a strong tradition of quality and excellence since its founding in 1992. Bordeaux Inspired - Distinctly Washington - Uniquely DeLille. Try DeLille's popular D2 wine, which always leads with Merlot. It's a Bordeaux-style blend sourced from over a dozen of Washington's most prestigious vineyards across the Columbia Valley. Ask about the numerous private event spaces available for small and large gatherings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-ceec-700d-b930-7f3bc1b27435.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-ceec-700d-b930-7f3bc1b27435",
        "storage_key": "property/6737460151193489/019d01a7-ceec-700d-b930-7f3bc1b27435.webp",
        "width": 660,
        "height": 432
      },
      "poi_business_url": "https://www.yelp.com/biz/delille-cellars-woodinville?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.734785,-122.148939",
      "poi_item_slug": "delille-cellars-woodinville",
      "poi_latitude": "47.734785",
      "poi_longitude": "-122.148939",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+14254890544",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJifi4Oy0NkFQRbdTP91eyNHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_56639772-db10-4597-8261-49f900919635",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Ryan James Fine Arts",
      "poi_type": "Entertainment",
      "poi_address": "425 Urban Plz, Ste 165, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "ryan james fine arts founded in 2011, by Ryan James, is a contemporary art gallery in Kirkland representing a roster of 25 artists working in the style of modern, abstract, and conceptual arts. Joined by Jessica Kravitz, in 2014, these partners cultivate a gallery program that fosters the careers of known and emerging artists alike. Our focus is to work with artists that adhere to an ideal set of principles and disciplines while building a unified body of work.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-d06b-712d-b64f-dba2dfa79b9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-d06b-712d-b64f-dba2dfa79b9c",
        "storage_key": "property/6737460151193489/019d01a7-d06b-712d-b64f-dba2dfa79b9c.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.yelp.com/biz/ryan-james-fine-arts-kirkland-2?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.67792562792136,-122.19877432457083",
      "poi_item_slug": "ryan-james-fine-arts-kirkland-2",
      "poi_latitude": "47.67792562792136",
      "poi_longitude": "-122.1987743245708",
      "poi_miles_from_property": "0.07",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+14258149500",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJYeQ-m4tskFQRXnQ_ufzCahM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_71956a96-4ca4-4a57-8f1a-f18e125b44b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "custom",
      "poi_name": "Studio East",
      "poi_type": "Entertainment",
      "poi_address": "348 Kirkland Ave, Kirkland, WA 98033",
      "poi_short_description": "",
      "poi_long_description": "Studio East introduces young people to the performing arts through classes, camps, workshops and live theater performances!",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/019d01a7-d1c4-7598-aa19-ac1f008bcf55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a7-d1c4-7598-aa19-ac1f008bcf55",
        "storage_key": "property/6737460151193489/019d01a7-d1c4-7598-aa19-ac1f008bcf55.webp",
        "width": 664,
        "height": 1000
      },
      "poi_business_url": "https://www.yelp.com/biz/studio-east-kirkland?adjust_creative=IVEx-e0fZ-RnHlZfoOnHmw&utm_campaign=yelp_api_v3&utm_medium=api_v3_business_search&utm_source=IVEx-e0fZ-RnHlZfoOnHmw",
      "poi_directions_map_url": "https://maps.google.com/?q=47.67603251089033,-122.20112410636771",
      "poi_item_slug": "studio-east-kirkland",
      "poi_latitude": "47.67603251089033",
      "poi_longitude": "-122.2011241063677",
      "poi_miles_from_property": "0.24",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+14258201800",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "ChIJe8b3LgsSkFQRtEWXFZRoRbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_cc25993699b7a05efa0d32ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_661e1df5b20c969064494272",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f1032103d342f982bd960144",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_61cc98fb63c9fee7b0f9f2c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6bd2ef8ceaa30b42adc0e2bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_20933af2aa95ecbb17b47ea1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "rating": "5",
      "name": "Lacey Politano",
      "text": "I recently did a tour with Cori, she was so incredibly nice and was able to assist with any questions I had and addressed my concerns that I have with any apartment tour. These apartments were very beautiful and will definitely keeping them in consideration at the top of my list for my continued apartment hunt. Thank you Cori!",
      "date": "2026-07-13",
      "title": "false"
    },
    {
      "id": "ec_e33a81571ed93014034b50a7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "rating": "4",
      "name": "Stevie L",
      "text": "edit: Previously I put 2 stars because of being very disappointed about upstair neighbors not respecting the community quite hours plus the fact that the floors are very thin in this building. But to be fair, this could have not been an issue if we can all be mindful and avoid making noises to our downstairs neighbors. My own upstairs neighbors living on the top floor has been dragging chairs every early morning sometimes before 6am, but at least the leasing office has been very responsive to help me communicating to them. Will need some time to see how it goes…\n\nUpdated review:\nI enjoyed everything about this apartment so far except for the noise issue I mentioned above. Nice gym, plenty of storage spaces in unit, the location, etc.\nAnd big kudos to Cori, being so warm, sweet, responsive, helpful, during my on-site tour and for moving-in logistics, and also about the noise complaints.",
      "date": "2026-06-11",
      "title": "false"
    },
    {
      "id": "ec_69fbd1cf98b1f26e425cfed5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "rating": "5",
      "name": "Stella R",
      "text": "I really appreciate the leasing team, Francisco and Cori, especially Francisco. He is always super nice, caring, and responsive, and he brings such positive energy every single day. Every request I’ve had, including maintenance, has been handled quickly and with care. They are professional and genuinely supportive, which has made living here such a wonderful experience.\n\nIt has truly been a pleasure calling this apartment my home, and I feel grateful for the kindness and dedication of the team and with Francisco!",
      "date": "2025-09-16",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_af5d2a630cb8ddfcaa512f15",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/01a03acd-2359-77ab-8621-b2ff91806187.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03acd-2359-77ab-8621-b2ff91806187",
        "storage_key": "property/6737460151193489/01a03acd-2359-77ab-8621-b2ff91806187.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Uptown Kirkland Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JkJ7Dk3Z3LR"
    },
    {
      "id": "ec_2053daa425481a56bd598fc4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/01a03acd-2565-74c0-b3c0-944ad774ac54.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03acd-2565-74c0-b3c0-944ad774ac54",
        "storage_key": "property/6737460151193489/01a03acd-2565-74c0-b3c0-944ad774ac54.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Uptown Kirkland  221",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=HPNpdqeoF1u"
    },
    {
      "id": "ec_0e960ce0bc77aac54c21ec25",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151193489/01a03acd-2276-76cb-b7e3-c87473100354.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03acd-2276-76cb-b7e3-c87473100354",
        "storage_key": "property/6737460151193489/01a03acd-2276-76cb-b7e3-c87473100354.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Uptown Kirkland  Unit 416",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Vm3mpUUEFM3"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_c75bcee80c53b00749a23116",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "775d5b715d7880ac",
      "name": "Early Termination Fee",
      "description": "Early Termination Fee",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Term",
      "charge_code": "term",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2cecb916d24e3c5c46f20716",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "e64beea0bd901760",
      "name": "NSF Tenant Fee",
      "description": "NSF Tenant Fee",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "nsff",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_25c8f1f1fded219edcd05194",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "09937a10eedc9584",
      "name": "Late Fee",
      "description": "Late Fee",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "$5 per day up to 20 days",
      "amount_type": "text",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "late",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_eb4bc6e910668b6cc5669c80",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "23f5f8e569929e0e",
      "name": "2nd Late Fee",
      "description": "2nd Late Fee",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "late",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2f46681056c613c373a801e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "7c65ca5b9ae84d37",
      "name": "Transfer Fee",
      "description": "Fee to transfer apartments",
      "amount": 800,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Transfer",
      "charge_code": "tran",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4582fe9bf3350bd7cce83542",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "efc83f2df1c94439",
      "name": "Water Charge",
      "description": "Water Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Individually metered, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubwater",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6a5a62f411b3871fc87fd035",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "52754ec531f0db4e",
      "name": "Sewer Charge",
      "description": "Sewer Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on square footage and occupancy",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewer",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_690208384d31664c5087d412",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "3739d8257125b796",
      "name": "Garbage Charge",
      "description": "Garbage Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubtrash",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_61cbe30d54e4edea7508ef60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "fd132f56d49bc82b",
      "name": "Pest Control",
      "description": "Pest Control Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "pest",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_15d83f668355e9e50aff840f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "b02365b8ac7df85f",
      "name": "Gas Charge",
      "description": "Gas Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on square footage and occupancy",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "gasc",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_42f849f2736ef107ffe0d529",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "f12295e4a9608bb1",
      "name": "Sewer Capacity Fee",
      "description": "Sewer Capacity Fee",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewer",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6b41cb91fde5addf71203009",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "7aba17d1c375f702",
      "name": "Common Area Electric",
      "description": "Common Area Electric Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "elec",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_7df7fae3cb3bfa550d1ef79a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "ff29537efdd06585",
      "name": "Utility Billing Admin Fee",
      "description": "Utility Admin Fee",
      "amount": 5,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubadmin",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [
    {
      "id": "ec_c43c56da4d00c890b87f2338",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "2472490",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 300,
      "monthly_rent": 50,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_d4ebb4bb3d14885d9bffd155",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "yardi",
      "external_id": "2472489",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 300,
      "monthly_rent": 50,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply. Pets over 70 lbs are subject to management interview."
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-b0a6-77ac-a1c0-38aabbcf0943",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "uptown-at-kirkland-urban",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489"
    },
    {
      "lead_collector_id": "0198aa47-b108-721b-bc3f-a9fa2b4b678f",
      "lead_source": "FACEBOOK_ADS",
      "name": "uptown-at-kirkland-urban",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489"
    },
    {
      "lead_collector_id": "0198aa47-b16b-7546-bd54-94eb2140ffe0",
      "lead_source": "LANDING_PAGE",
      "name": "uptown-at-kirkland-urban",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-kirkland-wa",
      "search_query": "pet-friendly apartments Kirkland WA",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Kirkland WA",
      "h2_subtitle": "Discover Uptown at Kirkland Urban Offering Pet-Friendly Living in the Heart of Kirkland, WA.",
      "page_copy": "If you're searching for pet-friendly apartments in Kirkland, WA, Uptown at Kirkland Urban offers an ideal choice. Nestled in the vibrant Moss Bay neighborhood, our community combines modern conveniences and scenic Lake Washington views, catering specifically to pet lovers. Your furry friends will love exploring the welcoming community atmosphere and nearby open areas while you enjoy the luxurious amenities.\n\nFrom the pet-friendly atmosphere to convenient access to I-405, Uptown at Kirkland Urban provides a perfect blend of comfort and accessibility. Imagine enjoying evenings in the resident lounge with a full kitchen or taking in the breathtaking cityscape views while knowing your four-legged companion is right at home. Experience pet-friendly elegance right in the heart of Downtown Kirkland, WA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white quartz countertops, and dark wood cabinetry.",
        "public_id": "019d01a6-2a05-7258-9f38-b5a72126f242",
        "storage_key": "property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Kirkland WA",
      "seo_description": "Explore pet-friendly apartments at Uptown at Kirkland Urban, where modern living and pet comfort meet in downtown Kirkland, WA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "generator",
      "page_item_url": "luxury-apartments-rooftop-terrace-moss-bay",
      "search_query": "luxury apartments with rooftop terrace Moss Bay",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Rooftop Terrace",
      "h2_subtitle": "Uptown at Kirkland Urban Offers Luxury with Stunning Rooftop Terrace Views in Moss Bay.",
      "page_copy": "Experience the pinnacle of luxury living with rooftop terrace access at Uptown at Kirkland Urban in Moss Bay. Situated in Kirkland, WA, our apartments offer not only a modern and stylish interior but also provide breathtaking rooftop views of Lake Washington, perfect for social gatherings or personal relaxation.\n\nResidents indulge in upscale amenities such as a fully equipped lounge, textured cabinetry, and pet-friendly options. Enjoy the convenience of location with easy access to I-405 while taking in the spectacular city and lake vistas from our rooftop terrace. Make Uptown at Kirkland Urban your new home and embrace luxury living with unmatched elegance in the heart of Moss Bay.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white quartz countertops, and dark wood cabinetry.",
        "public_id": "019d01a6-2a05-7258-9f38-b5a72126f242",
        "storage_key": "property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Rooftop Terrace",
      "seo_description": "Discover luxury living at Uptown in Moss Bay, featuring stunning rooftop terrace views and modern amenities in Kirkland, WA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-king-county",
      "search_query": "apartments with in-unit laundry King County",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in King County",
      "h2_subtitle": "Find Comfort at Uptown at Kirkland Urban, Where In-Unit Laundry Meets Modern Living in King County.",
      "page_copy": "Uptown at Kirkland Urban in King County offers modern apartments with the convenience of in-unit laundry. Located in the dynamic Moss Bay neighborhood of Kirkland, WA, our community is designed for comfort and convenience. Enjoy hassle-free living with in-unit laundry that allows you more time to relax and take in the stunning Lake Washington views.\n\nOur residents appreciate the harmonious blend of modern amenities, including a resident lounge, fully equipped kitchen, and pet-friendly spaces. With quick access to I-405, Uptown at Kirkland Urban is the perfect choice for those seeking style, convenience, and efficiency in King County. Discover the relaxed yet elegant lifestyle that awaits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white quartz countertops, and dark wood cabinetry.",
        "public_id": "019d01a6-2a05-7258-9f38-b5a72126f242",
        "storage_key": "property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry King County",
      "seo_description": "Discover Uptown at Kirkland Urban, where modern apartments with in-unit laundry offer convenience and comfort in King County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "generator",
      "page_item_url": "kirkland-apartments-with-air-conditioning",
      "search_query": "Kirkland apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Kirkland Apartments with Air Conditioning",
      "h2_subtitle": "Stay Cool and Comfortable at Uptown at Kirkland Urban, Featuring Air Conditioning for All Seasons.",
      "page_copy": "Experience the ideal blend of comfort and style with Uptown at Kirkland Urban, where Kirkland apartments feature air conditioning to keep you cool year-round. Located in the picturesque Moss Bay neighborhood, our community provides not only beautiful lake views but also the modern amenities you need to enjoy every moment.\n\nOur apartments are designed with your comfort in mind, offering air conditioning alongside upscale features like resident lounges and city views. Enjoy seamless access to I-405 and the vibrant lifestyle of Downtown Kirkland. At Uptown at Kirkland Urban, comfort and convenience come together to ensure a refreshing living experience tailored just for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white quartz countertops, and dark wood cabinetry.",
        "public_id": "019d01a6-2a05-7258-9f38-b5a72126f242",
        "storage_key": "property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Kirkland Apartments with Air Conditioning",
      "seo_description": "Enjoy cool living at Uptown at Kirkland Urban, offering stylish apartments with air conditioning in the heart of Kirkland, WA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "generator",
      "page_item_url": "lake-washington-view-apartments-for-rent-kirkland",
      "search_query": "Lake Washington view apartments for rent",
      "category": "Amenity",
      "h1_title": "Lake Washington View Apartments for Rent",
      "h2_subtitle": "Discover Stunning Lake Washington Views from Uptown at Kirkland Urban's Apartments for Rent.",
      "page_copy": "Embrace breathtaking scenery at Uptown at Kirkland Urban, where apartments for rent offer stunning Lake Washington views. Located in the vibrant neighborhood of Moss Bay in Kirkland, WA, our community is designed to provide not only visual appeal but also luxurious amenities.\n\nResidents enjoy extraordinary comforts such as a resident lounge with a full kitchen and pet-friendly spaces. With seamless access to I-405, Uptown caters to those who value convenience and luxury. Come home to panoramic views of Lake Washington and experience the perfect balance of elegance and modernity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white quartz countertops, and dark wood cabinetry.",
        "public_id": "019d01a6-2a05-7258-9f38-b5a72126f242",
        "storage_key": "property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lake Washington View Apartments for Rent",
      "seo_description": "Rent at Uptown at Kirkland Urban and enjoy luxury living with stunning views of Lake Washington in the heart of Kirkland, WA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "generator",
      "page_item_url": "studio-apartments-kirkland-wa",
      "search_query": "studio apartments in Kirkland WA",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Kirkland, WA",
      "h2_subtitle": "Discover Cozy Studio Apartments at Uptown at Kirkland Urban in Kirkland, WA.",
      "page_copy": "Uptown at Kirkland Urban offers vibrant studio apartments in Kirkland, WA, perfect for those seeking efficiency and modern living. Nestled in the lively Moss Bay neighborhood, our studios provide a sophisticated space that balances style and function, complete with convenient Lake Washington views.\n\nResidents of Uptown at Kirkland Urban enjoy a variety of amenities, including a resident lounge and bike storage with a work station. These apartments offer quick access to I-405, making life in Kirkland, WA as convenient as it is charming. Experience the blend of modern comforts and urban vitality in our thoughtfully-designed studios.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white quartz countertops, and dark wood cabinetry.",
        "public_id": "019d01a6-2a05-7258-9f38-b5a72126f242",
        "storage_key": "property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Kirkland, WA",
      "seo_description": "Explore Uptown at Kirkland Urban's stylish studio apartments, offering modern amenities in the heart of Kirkland, WA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-moss-bay",
      "search_query": "one bedroom apartments in Moss Bay",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Moss Bay",
      "h2_subtitle": "Explore Spacious One Bedroom Apartments at Uptown at Kirkland Urban in Moss Bay.",
      "page_copy": "Discover the perfect blend of comfort and convenience with one bedroom apartments at Uptown at Kirkland Urban, located in the desirable Moss Bay neighborhood. Our apartments offer a cozy yet expansive living experience, complemented by Lake Washington views and proximity to all the excitement of downtown Kirkland.\n\nThese elegantly designed one-bedroom apartments feature upscale amenities such as textured cabinetry and under-cabinet lighting, providing an ideal backdrop for both quiet evenings and entertaining guests. Enjoy the benefits of living in Moss Bay, with easy access to I-405 as well as vibrant local dining and shopping options.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white quartz countertops, and dark wood cabinetry.",
        "public_id": "019d01a6-2a05-7258-9f38-b5a72126f242",
        "storage_key": "property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Moss Bay",
      "seo_description": "Find your ideal home at Uptown at Kirkland Urban with our spacious one bedroom apartments in the appealing Moss Bay neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6737460151193489",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-lake-washington",
      "search_query": "two bedroom apartments near Lake Washington",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Lake Washington",
      "h2_subtitle": "Discover Spacious Two Bedroom Apartments Steps from Lake Washington at Uptown at Kirkland Urban.",
      "page_copy": "Uptown at Kirkland Urban offers elegantly designed two bedroom apartments near the serene Lake Washington. These residences provide the perfect setting for families or roommates seeking a spacious living environment combined with modern luxury. Nestled in the vibrant Moss Bay neighborhood, these apartments offer more than just a place to live—they provide a lifestyle close to natural beauty and urban conveniences.\n\nEach two-bedroom apartment features thoughtfully designed interiors, including a resident lounge and high-quality finishes, ensuring comfort at every turn. The proximity to key amenities and easy access to I-405 make this location ideal for those who seek a harmonious blend of city and nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white quartz countertops, and dark wood cabinetry.",
        "public_id": "019d01a6-2a05-7258-9f38-b5a72126f242",
        "storage_key": "property/6737460151193489/019d01a6-2a05-7258-9f38-b5a72126f242.webp",
        "width": 1640,
        "height": 900
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Lake Washington",
      "seo_description": "Live in style at Uptown at Kirkland Urban's two bedroom apartments near Lake Washington, offering modern amenities and a perfect location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4737"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9147445658"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4257286422"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T88RMQXK"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7.1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Aster"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/50d89c64-de47-47e3-b9bc-76bdc6843116/app.js?property=50d89c64-de47-47e3-b9bc-76bdc6843116&amp;propertyName=Uptown at Kirkland Urban&amp;channelUuid=4f0a4769-9305-11ee-a2af-42010aa8d42b\" defer=\"\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47571460889"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ims2UmE2bU1OR2NvUzMzZTRMNzJNbkE9PSIsInZhbHVlIjoiVlVRY2IxQXJSTEcyS0ZrazJKZWMzZz09IiwibWFjIjoiOGQxNjgzNzE4NTZhMDllZjZlOGUzODJiNGU2NzU4NjFiNGMxYzQ0ZWQ5NTc3YWVmMzBiNTM1MWNkZTZhODVmYyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "4737",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9147445658",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4257286422",
  "custom_google_gtm_id": "GTM-T88RMQXK",
  "custom_rollout_phase": "Phase 7.1",
  "custom_vibesites_theme": "Aster",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/50d89c64-de47-47e3-b9bc-76bdc6843116/app.js?property=50d89c64-de47-47e3-b9bc-76bdc6843116&amp;propertyName=Uptown at Kirkland Urban&amp;channelUuid=4f0a4769-9305-11ee-a2af-42010aa8d42b\" defer=\"\"></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47571460889",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ims2UmE2bU1OR2NvUzMzZTRMNzJNbkE9PSIsInZhbHVlIjoiVlVRY2IxQXJSTEcyS0ZrazJKZWMzZz09IiwibWFjIjoiOGQxNjgzNzE4NTZhMDllZjZlOGUzODJiNGU2NzU4NjFiNGMxYzQ0ZWQ5NTc3YWVmMzBiNTM1MWNkZTZhODVmYyJ9",
  "custom_audioeye_site_id": "248b85e3-ea93-4a57-b8ad-a6e58ff73cd1",
  "custom_audioeye_site_hash": "94c24999b9fbdd6c039f7408a3ce0a76"
};

export const generatedAt = '2026-11-03T00:32:08.908Z';
